import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const Click6NinjaGrid = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'click-6-grid');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default Click6NinjaGrid;
